/**
 * MODULE: _shared/frontend-shell/src/services/langflowFlowId.ts
 * PURPOSE: Align shell Langflow flow id checks with backend **`is_unwired_langflow_flow_id`** (nil UUID + 0000…-4000-8000- placeholders) and template .env strings.
 * RECENT: 2026-04-27 — [2.2.703] **`looksLikeLangflowUuidCandidate`** + **`PERPLEXITY_ASSISTANT_LANGFLOW.md`** — root **`CHANGELOG` [2.2.703]**. 2026-04-26 — shared with **`AiAssistantPanel`** / **`langflowAssistantFlow`** for env vs list-resolved flow ids — root **`CHANGELOG` [2.2.702]**.
 */

const UNWIRED_4000_8000 = /^00000000-0000-4000-8000-[0-9a-f]{12}$/i;

/** True for empty, nil UUID, or seeded 00000000-0000-4000-8000-… placeholders (matches platform / orchestration). */
export function isUnwiredLangflowFlowId(value: string): boolean {
  const s = value.trim().toLowerCase();
  if (!s) return true;
  if (s === '00000000-0000-0000-0000-000000000000') return true;
  return UNWIRED_4000_8000.test(s);
}

/** True when the string looks like a user-pasted UUID (vs empty or README placeholders). */
export function looksLikeLangflowUuidCandidate(value: string): boolean {
  const s = value.trim();
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(s);
}

/** Non-empty flow id suitable for runs: not unwired and not .env template copy-paste. */
export function isConcreteLangflowFlowId(flowId: string): boolean {
  if (isUnwiredLangflowFlowId(flowId)) return false;
  const t = flowId.trim().toLowerCase();
  if (
    t === 'your-flow-uuid-here' ||
    t === 'your-flow-uuid-from-langflow-settings' ||
    t === 'your-real-flow-uuid-here'
  ) {
    return false;
  }
  if (t.startsWith('your-flow')) return false;
  return true;
}
